module.exports = __webpack_public_path__ + "img/75626.8cd6e14b.svg";